import videojs from 'video.js';
import { LAYOUTS } from './multistream/layouts.js';

export class MultistreamPluginStub extends videojs.getPlugin('plugin') {
    constructor(player, options) {
        super(player, options);

        player.loader().onLoadPresentation(onLoadPresentation.bind(player));
    }
}

function sortByPlaybackAudioSource(a, b) {
    if (a.playbackAudioSource && !b.playbackAudioSource) {
        return -1;
    }
    if (b.playbackAudioSource && !a.playbackAudioSource) {
        return 1;
    }
    return 0;
}

function sortByAudioOnly(a, b) {
    if (a.audioOnly && !b.audioOnly) {
        return -1;
    }
    if (b.audioOnly && !a.audioOnly) {
        return 1;
    }
    return 0;
}

function shouldLoad(presentationId, playCoverData, presentationData) {
    return (presentationData?.streams?.length ?? 0) > 1;
}

function findVisualItemBySourceId(composition, sourceId) {
    return composition.VisualItems.find(item => item.SourceId === sourceId);
}

async function onLoadPresentation(presentationId, playCoverData, presentationData) {
    const player = this;
    if (shouldLoad(...arguments)) {
        if (!videojs.getPlugin('multistream')) {
            const { MultistreamPlugin } = await import(/* webpackChunkName: 'multistream' */ './multistream.js');
            player.registerPlugin('multistream', MultistreamPlugin);
        }
        
        player.multistream().init();

        const map = presentationData.compositionMap;
        const comp = map?.VisualCompositions[0];

        //If streams are audioOnly, shouldn't be used to determine layout of visible streams
        //Multistream layouts determine aspect ratio based on number of streams
        //values for x, y, width, and height are assigned from layout based on index of streams
        let streams = presentationData.streams
            .slice()
            .sort(sortByAudioOnly)
            .map((stream) => {
                if (stream.audioOnly === true) {
                    return Object.assign({}, stream, {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0.01
                    });
                } else {
                    const visualItem = findVisualItemBySourceId(comp, stream.id);
                    const streamLayoutInfo = {
                        x: visualItem.TargetRect.X,
                        y: visualItem.TargetRect.Y,
                        width: visualItem.TargetRect.Width,
                        height: visualItem.TargetRect.Height
                    };
                    return Object.assign({}, stream, streamLayoutInfo);
                }
            });
        streams.sort(sortByPlaybackAudioSource);

        // Wait for each stream to load
        const multistreams = streams.slice(1);
        return Promise.all(multistreams.map(stream => {
            return player.multistream().add(stream);
        })).then(() => {
            // "Priority" property determines the order in which streams should appear on screen
            // PlaybackAudioSource determines which stream is the "main" one attached to the top-level player.
            // Set the priority of the main stream in the multistream plugin layout
            const { x, y, width, height } = streams[0];
            player.multistream().setMainStreamSize(x, y, width, height);
            player.smartzoom().addRegion({
                left: x,
                top: y,
                width,
                height,
                id: 'multistream-main'
            });
            const aspect = comp.Width / comp.Height;
            player.multistream().aspect = aspect;
            return { streams };
        });
    }
}
